// Sentry initialization for frontend error tracking
import * as Sentry from "@sentry/browser"

// Get Sentry DSN from meta tag (set in application layout)
const sentryDsn = document.querySelector('meta[name="sentry-dsn"]')?.getAttribute('content')
const sentryEnvironment = document.querySelector('meta[name="sentry-environment"]')?.getAttribute('content') || 'development'

// Only initialize Sentry if DSN is available
if (sentryDsn && sentryDsn !== '') {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    
    // Set sample rate for performance monitoring (0.0 to 1.0)
    // 1.0 = 100% of transactions, 0.1 = 10% of transactions
    tracesSampleRate: sentryEnvironment === 'production' ? 0.1 : 1.0,
    
    // Capture unhandled promise rejections
    captureUnhandledRejections: true,
    
    // Integrate with Turbo (Hotwire)
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Only enable session replay in production for a small percentage of sessions
        sessionSampleRate: sentryEnvironment === 'production' ? 0.1 : 1.0,
        // Enable error replay for all sessions
        errorSampleRate: 1.0,
      }),
    ],
    
    // Filter out sensitive data
    beforeSend(event, hint) {
      // Filter out sensitive information from URLs
      if (event.request && event.request.url) {
        event.request.url = event.request.url.replace(/password=[^&]*/gi, 'password=[FILTERED]')
        event.request.url = event.request.url.replace(/token=[^&]*/gi, 'token=[FILTERED]')
        event.request.url = event.request.url.replace(/api_key=[^&]*/gi, 'api_key=[FILTERED]')
      }
      
      // Filter sensitive data from request body
      if (event.request && event.request.data) {
        const sensitiveKeys = ['password', 'password_confirmation', 'credit_card', 'cvv', 'ssn', 'token', 'secret', 'api_key']
        sensitiveKeys.forEach(key => {
          if (event.request.data[key]) {
            event.request.data[key] = '[FILTERED]'
          }
        })
      }
      
      return event
    },
    
    // Ignore certain errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'atomicFindClose',
      // Network errors
      'NetworkError',
      'Network request failed',
      // Turbo errors
      'Turbo',
    ],
    
    // Don't send errors from localhost in production
    denyUrls: sentryEnvironment === 'production' ? [
      /localhost/,
      /127\.0\.0\.1/,
    ] : [],
  })
  
  // Set user context when available (can be set from Rails via window.Sentry.setUser)
  // Example: window.Sentry.setUser({ id: '123', email: 'user@example.com' })
  
  // Capture Turbo errors
  document.addEventListener('turbo:load', () => {
    // Set context for Turbo navigation
    Sentry.setContext('navigation', {
      type: 'turbo',
      url: window.location.href,
    })
  })
  
  // Make Sentry available globally for manual error reporting
  window.Sentry = Sentry
  
  console.log('Sentry initialized for frontend error tracking')
} else {
  console.log('Sentry DSN not configured - frontend error tracking disabled')
}
